import { Link } from "react-router-dom"
import styled from "styled-components"

const StyledLink = styled(Link)`
  opacity: .8;
  transition: opacity 100ms ease;
  display: grid;
  place-items: center;

  :hover {
    opacity: 1;
  }
`


const LinkExchange = ({ to, children }) => (
  <StyledLink to={{ pathname: to }} target='_blank' rel='noopener noreferrer'>
    {children}
  </StyledLink>
)

export default LinkExchange